import { BlankSlate } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmptySpendings = () => {
  return (
    <BlankSlate
      title={i18n.t('budgets.detail.tabs.spendings.blank_slate.title')}
      description={i18n.t('budgets.detail.tabs.spendings.blank_slate.description')}
      illustration="money-bag"
    />
  )
}

export default EmptySpendings
